import {Policy} from './PolicyConstants';

export default function getPolicyName(policy: Pick<Policy, 'name'>): string {
  return policy.name.toUpperCase();
}
